import { Divider, Grid } from "@material-ui/core";
import "react-nice-dates/build/style.css";
import Loading from "../../../components/basics/Loading";

import HeaderModule from "../../../components/header/HeaderModule";

import {
  Filter,
  ReportActions,
  ReportDataGrid,
  ReportHeader,
} from "./children";
import {
  ResultadoExercicioProvider,
  useResultadoExercicioService,
} from "./contexts/ResultadoExercicioContext";

const View = () => {
  const { reLoading, reRefetchLoading, isConsolidated } =
    useResultadoExercicioService();

  return (
    <>
      <HeaderModule title="RESULTADO DO EXERCÍCIO" />
      <Loading open={reLoading || reRefetchLoading} />
      <Grid
        container
        direction="column"
        style={{ marginTop: 80, marginBottom: 40, padding: "0px 16px" }}
        spacing={2}
      >
        <Filter />

        <ReportHeader
          reportType={isConsolidated ? "Consolidado" : "Detalhado"}
        />
        <ReportActions />
        <Divider />

        <ReportDataGrid />
      </Grid>
    </>
  );
};

const ResultadoExercicio = (props) => (
  <ResultadoExercicioProvider>
    <View {...props} />
  </ResultadoExercicioProvider>
);

export default ResultadoExercicio;
